import { render, staticRenderFns } from "./bg_lvzhi.vue?vue&type=template&id=4a3fb419&scoped=true&"
import script from "./bg_lvzhi.vue?vue&type=script&lang=js&"
export * from "./bg_lvzhi.vue?vue&type=script&lang=js&"
import style0 from "./bg_lvzhi.vue?vue&type=style&index=0&id=4a3fb419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3fb419",
  null
  
)

export default component.exports